var SupportedLocale;
(function (SupportedLocale) {
    SupportedLocale["AR_SA"] = "ar-sa";
    SupportedLocale["DE_DE"] = "de-de";
    SupportedLocale["EN_GB"] = "en-gb";
    SupportedLocale["EN_US"] = "en-us";
    SupportedLocale["ES_AR"] = "es-ar";
    SupportedLocale["ES_CO"] = "es-co";
    SupportedLocale["ES_MX"] = "es-mx";
    SupportedLocale["PT_BR"] = "pt-br";
})(SupportedLocale || (SupportedLocale = {}));
export { SupportedLocale, };
//# sourceMappingURL=supported-locale.js.map